import type { Directive } from "vue";

export const vAutoFocus: Directive<HTMLInputElement | HTMLTextAreaElement> = {
	mounted(el) {
		el?.focus();
	},
};
